






import { Component, Vue } from 'vue-property-decorator';
import ToastModule from '@/store/modules/toast';

@Component({
  components: {},
})
export default class ToastNotification extends Vue {
  get show() {
    return ToastModule.show;
  }

  get message() {
    return ToastModule.message;
  }

  get error() {
    return ToastModule.error;
  }

  public close() {
    ToastModule.hideToast();
  }
}
